export default __webpack_public_path__ + "static/media/NotificationTaskIcon.9576c845.svg";